
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => {
    return {
        footer: {
            display: "flex",
            justifyContent: "center",
            marginTop: theme.spacing(4),
        },
    };
});
